import React from "react";
import { Stack, Divider, Typography } from "investira.react.components";
import DetalheTable from "./DetalheTable";

const Detalhes = ({ label = "", detalhe = [] }) => {
  console.log(detalhe);
  return (
    <Stack>
      <Stack mb={0.5} sx={{ flex: 1 }}>
        <Stack mx={2} my={1} direction="row" alignItems="center" spacing={1}>
          <Typography variant="body2" color="textPrimary">
            {label}
          </Typography>
        </Stack>
        <Divider />
      </Stack>
      <DetalheTable detalhe={detalhe || []} />
    </Stack>
  );
};

export default Detalhes;
